<template>
  <v-container fluid>
    <v-layout row>
      <Header title="Ochrana osobných údajov" subtitle="www.duris.info" />
    </v-layout>
    <v-layout row wrap align-center justify-center fill-height class="pt-5">
      <v-flex xs12 sm6 md6 lg6>
        <p>Osobné údaje sú &nbsp;spracovávané v súlade so &nbsp; zákonom &nbsp;Slovenskej republiky &nbsp;č. 18/2018 Z. z. o ochrane osobných údajov a o zmene a doplnení niektorých zákonov, ktorý najmä v §19-30 upravuje práva dotknutej osoby v oblasti spracovania osobných údajov .</p>
        <p>Súhlas so spracovaním osobných údajov pri objednávkach a pri registrácii:</p>
        <ul>
          <li>
            <strong>
              Identifikačné údaje prevádzkovateľa a zodpovednej osoby
              <br />
              <br />
            </strong>Prevádzkovateľom osobných údajov je firma Ing.PaedDr.Vladimír Ďuriš, IČO 30752728 , zapísaná v Živnostenskom registri č.203-1167 Okresného úradu Trnava , ktorá spracúva osobné údaje za podmienok uvedených nižšie.
            <br />
            <br />Firma &nbsp;prostredníctvom svojej webovej stránky umožňuje klientom a zákazníkom registráciu do systému. Konkrétne osobné údaje budú použité pre oblasť automatického doplňovania údajov pri Vašich objednávkach a prípadného zasielania informacií o našich produktoch a novinkách .
          </li>
        </ul>
        <p style="line-height: 1;">
          <br />
        </p>
        <ul>
          <li>
            <strong>
              Zásady ochrany osobných údajov
              <br />
              <br />
            </strong>Pri spracúvaní osobných údajov prevádzkovateľom ste dotknutou osobou, t. j. osobou o ktorej sú spracúvané osobné údaje, ktoré sa jej týkajú. V súlade s Nariadením a Zákonom o ochrane osobných údajov firma ako prevádzkovateľ, spracúva vaše osobné údaje v rozsahu a za podmienok ustanovených v osobitných predpisoch.
            <br />
            <br />Vaše osobné údaje spracúvame len na základe zákonných podmienok, ktoré sú uvedené v Zákone o ochrane osobných údajov.
            <br />
            <br />Vaše osobné údaje nepredávame ani nesprístupňujeme tretím osobám.
            <br />
            <br />Vaše osobné údaje budú uchovávané bezpečne a prístup k vašim osobným údajom budú mať výlučne osoby poverené prevádzkovateľom na spracúvanie osobných údajov, najmä zodpovedná osoba, ktoré ich spracúvajú na základe pokynov prevádzkovateľa, v súlade s bezpečnostnou politikou prevádzkovateľa. Vaše osobné údaje sú zálohované, v súlade s pravidlami prevádzkovateľa.
            <br />
            <br />Pokiaľ by sa v priebehu času čokoľvek zmenilo, budeme Vás o každej zmene informovať prostredníctvom Vami uvedeného e-mailu.
          </li>
        </ul>
        <p>
          <strong>&nbsp;</strong>
        </p>
        <p>
          <strong>Účel spracovania a zákonný základ spracovania:</strong>
        </p>
        <ul>
          <li>Zaistenie vybavenia objednávky</li>
          <li>Doručenie objednávky</li>
          <li>Plnenie práv vyplývajúcich z&nbsp;vadného plnenia, či náhradu škody</li>
        </ul>
        <p>&nbsp;</p>
        <p>Vaše osobné údaje &nbsp;poskytnuté pri registrácii do systému, t.j. &nbsp;pri vypĺňaní objednávky budeme spracovávať iba za týmto účelom:</p>
        <p>Právnym základom spracovania je plnenie zmluvy medzi &nbsp;našou spoločnosťou a Vami &nbsp;a ďalej aj plnenie zákonných povinností vyplývajúcich najmä zo zákona &nbsp;o ochrane spotrebiteľa &nbsp;a občianskeho zákonníka.</p>
        <p>V súlade s Nariadením a Zákonom o ochrane osobných údajov &nbsp;spoločnosť &nbsp;ako prevádzkovateľ, spracúva vaše osobné údaje v rozsahu a za podmienok ustanovených v osobitných predpisoch.&nbsp;</p>
        <p>V rámci registrácie do systému sú spracúvané vaše osobné údaje na vyššie uvedený účel na základe zákonných podmienok, uvedených v čl. 6 Nariadenia.</p>
        <p>
          <strong>Kategórie &nbsp;dotknutých osobných údajov:</strong>
        </p>
        <ul>
          <li>vaše meno a&nbsp;priezvisko, prípadne názov, telefónne číslo, e-mail,</li>
          <li>vo vzťahu k Vami zvolenej dodacej adrese &nbsp;názov ulice, popisné číslo, mesto a poštové smerovacie číslo</li>
          <li>vo vzťahu k&nbsp;fakturačnej adrese názov ulice, popisné číslo, mesto a&nbsp;poštové smerovacie číslo a&nbsp;tiež IČO a prípadne DIČ a&nbsp;číslo účtu.</li>
          <li>právo na prístup</li>
          <li>právo na výmaz</li>
          <li>právo na prenosnosť</li>
          <li>písomne zaslaním listu na adresu sídla spoločnosti s uvedením mena a priezviska zodpovednej osoby pod názvom spoločnosti,</li>
          <li>elektronicky zaslaním e-mailu na vyššie uvedenú e-mailovú adresu&nbsp;</li>
        </ul>
        <p>
          <br />
        </p>
        <p>
          <strong>Informácie o Vašich právach vo vzťahu k osobným údajom:</strong>
        </p>
        <p>V súvislosti so spracovaním osobných údajov máte radu práv.</p>
        <p>Môžete nás kedykoľvek &nbsp;požiadať o potvrdenie, či sú Vaše osobné údaje spracovávané a pokiaľ sú, máte právo na prístup k týmto osobným údajom a informáciám o nich. Máte právo na opravu nepresných alebo na doplnenie neúplných osobných údajov.</p>
        <p>Môžete nás kedykoľvek požiadať o vymazanie týchto osobných údajov, pokiaľ je pre to daný dôvod, alebo pokiaľ je preto daný dôvod o obmedzení spracovania týchto osobných údajov.</p>
        <p>Máte právo na Vaše osobné údaje a na ich prenos inému správcovi. Právo na prenosnosť sa však týka len osobných údajov, ktoré sme od vás získali na základe súhlasu alebo na základe zmluvy, ktorej ste jednou zo zmluvných strán.</p>
        <p>V prípade akýchkoľvek otázok, týkajúcich sa spracúvania vašich osobných údajov nás môžete kontaktovať prostredníctvom mailu alebo telefonicky.</p>
        <p>Máte právo kedykoľvek podať sťažnosť dozornému orgánu, ktorým je Úrad na ochranu údajov. &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp;</p>
        <p>
          <strong>Ďalšie spracovanie:</strong>
        </p>
        <p>Vaše osobné údaje sme obdržali iba od Vás.Osobné údaje, ktoré potrebujeme pre spracovanie, ktoré od nás vyžaduje zákon, nám poskytnúť musíte. Takisto nám musíte poskytnúť osobné údaje nevyhnutné pre plnenie povinnosti plynúcich z uzatvorenej zmluvy.</p>
        <p>Osobné údaje budú spracovávané iba na dobu nevyhnutne nutnú. Osobné údaje, ktorých spracovanie vyžaduje zákon spracovávame na dobu, na ktorú to zákon vyžaduje. Osobné údaje týkajúce sa plnenia z uzavretej zmluvy a ďalších súvisiacich &nbsp;práv a povinností budeme uchovávať len na dobu, na ktorú budú môcť byť tieto súvisiace práva a povinnosti vymáhateľné na súde.&nbsp;</p>
        <p>
          <strong>Záver:</strong>
        </p>
        <p>Potvrdením vo forme zaškrtnutím príslušného poľa o súhlase so spracovaním osobných údajov, potvrdzujete, že ste si túto informáciu prečítali, prevzali a je Vám zrozumiteľná. Pred podpisom (ale samozrejme aj kedykoľvek po ňom) sa neváhajte na čokoľvek ohľadom Vašich osobných údajov opýtať.</p>
        <p>&nbsp;</p>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Header from "@/components/widgets/Header";
export default {
  name: "Gdpr",
  components: {
    Header
  }
};
</script>

<style>
</style>